import config from 'app/config'
import { initializeApp } from 'firebase/app'

// Initialize Firebase
const app = initializeApp(config.firebaseWebConfig)

export default app
